module.exports = __webpack_public_path__ + "img/map_upper-box.680d37d1.jpg";